import React from 'react';
import { portfolio } from '../../models/content';

function PortfolioCompanyCard({ company }) {
  return (
    <article className="invco">
      <span className="invco-index">{company.index}</span>
      <div className="invco-main">
        <div className="invco-head">
          <span className="invco-sector">{company.sector}</span>
          <h3>
            {company.title}
            {company.titleSuffix ? (
              <>
                {' '}
                <em>{company.titleSuffix}</em>
              </>
            ) : null}
          </h3>
        </div>
        <p className="invco-desc">
          {company.description}
          {company.descriptionEmphasis ? <strong>{company.descriptionEmphasis}</strong> : null}
          {company.descriptionSuffix ?? ''}
        </p>
        {company?.stats?.length ? (
          <dl className="invco-stats">
            {company?.stats?.map((stat) => (
              <div key={stat.label}>
                <dt>{stat.label}</dt>
                <dd>
                  {stat.value}
                  {stat.unit ? (
                    <>
                      {' '}
                      <span>{stat.unit}</span>
                    </>
                  ) : null}
                </dd>
              </div>
            ))}
          </dl>
        ) : null}
        {company?.chips?.length ? (
          <ul className="invco-chips">
            {company?.chips?.map((chip) => (
              <li key={chip}>{chip}</li>
            ))}
          </ul>
        ) : null}
      </div>
    </article>
  );
}

export default function V2PortfolioPage() {
  return (
    <main>
      <section className="page-hero">
        <div className="wrap">
          <span className="v2-badge">
            <span className="dot" />
            {portfolio.heroBadge}
          </span>
          <h1>
            {portfolio.heroTitle.map((p, i) =>
              typeof p === 'string' ? (
                <React.Fragment key={i}>{p}</React.Fragment>
              ) : (
                <span key={i} className="it">
                  {p.it}
                </span>
              )
            )}
          </h1>
        </div>
      </section>

      <section>
        <div className="wrap">
          <p className="portfolio-intro">{portfolio.intro}</p>
          <div className="invco-list">
            {portfolio.companies?.map((company) => (
              <PortfolioCompanyCard key={company.index} company={company} />
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
